import api from "@/services/api";
import { buildCertificatePdf } from "@/components/common/CertificateDownload";
import { buildLetterPdf, Gender } from "@/components/common/LetterOfGoodStanding";

// Uint8Array → standard base64 (chunked to avoid call-stack limits on large PDFs).
const bytesToBase64 = (bytes: Uint8Array): string => {
  let binary = "";
  const chunk = 0x8000;
  for (let i = 0; i < bytes.length; i += chunk) {
    binary += String.fromCharCode.apply(null, Array.from(bytes.subarray(i, i + chunk)) as any);
  }
  return btoa(binary);
};

interface MembershipDocMeta {
  fullName: string;
  certId: string;
  date: string;
  city?: string;
  country?: string;
  gender?: Gender;
}

// Generates the ACA Certificate + Letter of Good Standing and emails both to the
// student (recipient resolved server-side from the application). Best-effort — callers
// should catch and surface failures softly. Returns the server response data.
export const emailMembershipDocs = async (applicationId: string, meta: MembershipDocMeta) => {
  const [certBytes, letterBytes] = await Promise.all([
    buildCertificatePdf(meta.fullName, meta.certId, meta.date),
    buildLetterPdf(meta.fullName, meta.certId.toUpperCase(), meta.date, meta.city, meta.country, meta.gender),
  ]);
  const res = await api.post("/documents/email", {
    applicationId,
    certificateBase64: bytesToBase64(certBytes),
    letterBase64: bytesToBase64(letterBytes),
  });
  return res.data;
};
